// v2 cache key: 2026-05-20 cutover from HS256 to ES256 signing. Old HS256
// tokens cached under the v1 key would keep failing for 24h until expiry,
// so we bump the key and let stale entries fall away naturally.
export const SUPABASE_JWT_KEY = 'coffee_rewards_supabase_jwt_v2';

export function getStoredSupabaseJwt(): string | null {
  if (typeof localStorage === 'undefined') return null;
  // localStorage can throw SecurityError in private-mode Safari, sandboxed
  // iframes, or when storage is blocked by site settings. Treat any failure
  // as "no token" so the caller falls back to minting fresh.
  try {
    return localStorage.getItem(SUPABASE_JWT_KEY);
  } catch {
    return null;
  }
}
